
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hI6CC", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $af65b479e9aa4397$export$7b3d03c2fa269586; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $eY3N6 = parcelRequire("eY3N6");

var $6iKF0 = parcelRequire("6iKF0");
parcelRequire("gKZds");
var $72aQB = parcelRequire("72aQB");

var $gsqLc = parcelRequire("gsqLc");
const $af65b479e9aa4397$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleOnError = (0, $gljCV.useCallback)((error)=>{
        createAnalyticsEvent({
            action: "failed",
            eventType: "track",
            actionSubject: "SoftwareRovoStartPage",
            source: "SoftwareRovoStartPage",
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $dypTs.jsx)((0, $gsqLc.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $72aQB.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("gKZds", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return (parcelRequire("72aQB")).SoftwareRovoStartPageTemplate; });

var $72aQB = parcelRequire("72aQB");

});
parcelRegister("72aQB", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $154413073beb82d2$export$89c9d15d38180eeb; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $eY3N6 = parcelRequire("eY3N6");

var $PE2DD = parcelRequire("PE2DD");

var $6Z2mc = parcelRequire("6Z2mc");

var $3riD8 = parcelRequire("3riD8");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $4weTV = parcelRequire("4weTV");

var $6VYIX = parcelRequire("6VYIX");
const $154413073beb82d2$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $gljCV.useState)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    const adminBaseUrl = (0, $gljCV.useMemo)(()=>{
        if (typeof window === "undefined") return "https://admin.atlassian.com";
        return (0, $6Z2mc.isProduction)() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    }, []);
    (0, $gljCV.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $gljCV.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPage",
            source: "softwareRovoStartPage",
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $gljCV.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error("Get account/orgs call failed");
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $gljCV.useCallback)(async ()=>{
        const productsUrl = (0, $6Z2mc.isProduction)() ? "https://rovo.atlassian.com" : "https://home.stg.atlassian.com/rovo";
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error("Get account/products call failed");
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes("rovo.ondemand"));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $gljCV.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $4weTV.LoginContactSales), {}) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $6VYIX.LoadingSpinner), {})
    });
};

});
parcelRegister("4weTV", function(module, exports) {
$parcel$export(module.exports, "LoginContactSales", function () { return $00bb124a426bfcbf$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");

var $gljCV = parcelRequire("gljCV");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $5yMx4 = parcelRequire("5yMx4");

var $99VqK = parcelRequire("99VqK");
var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $bHlSp = parcelRequire("bHlSp");
var $4HBPY = parcelRequire("4HBPY");

var $5qUgh = parcelRequire("5qUgh");
parcelRequire("l22jm");
var $8IYGL = parcelRequire("8IYGL");

var $k18Zl = parcelRequire("k18Zl");

var $2fk4i = parcelRequire("2fk4i");

var $6Z2mc = parcelRequire("6Z2mc");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $cxI2Y = parcelRequire("cxI2Y");
const $00bb124a426bfcbf$var$elevatedContainerInnerStyles = (0, $4HBPY.xcss)({
    textAlign: "center",
    paddingBlockStart: "space.500"
});
const $00bb124a426bfcbf$var$bodyTextStyles = (0, $4HBPY.xcss)({
    paddingBlockStart: "space.100"
});
const $00bb124a426bfcbf$var$loginButtonStyles = (0, $4HBPY.xcss)({
    paddingBlockStart: "space.400",
    paddingBlockEnd: "space.400",
    paddingInlineStart: "space.800",
    paddingInlineEnd: "space.800"
});
const $00bb124a426bfcbf$var$contactAtlassianStyles = (0, $4HBPY.xcss)({
    justifyContent: "center"
});
const $00bb124a426bfcbf$var$relative = null;
const $00bb124a426bfcbf$var$whiteBackground = null;
const $00bb124a426bfcbf$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    const fireButtonAnalytics = (0, $gljCV.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "loginContactSalesScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $gljCV.useCallback)(()=>fireButtonAnalytics("loginButton"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $gljCV.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $gljCV.useMemo)(()=>{
        if (typeof window === "undefined") return "id.atlassian.com/";
        return (0, $6Z2mc.isProduction)() ? "https://id.atlassian.com/" : "https://id.stg.internal.atlassian.com/";
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            "aria-label": "Contact Atlassian Page",
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $8AQXb.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $dypTs.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $k18Zl.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5yMx4.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $9HSUa.default), {
            xcss: $00bb124a426bfcbf$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).rovoGetStarted), {
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $dypTs.jsx)((0, $cxI2Y.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $99VqK.default), {
                    xcss: $00bb124a426bfcbf$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $bHlSp.default), {
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).rovoBodyText))
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $99VqK.default), {
                    xcss: $00bb124a426bfcbf$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $8AQXb.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsxs)((0, $7OBrw.default), {
                    space: "space.100",
                    xcss: $00bb124a426bfcbf$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).dontHaveAccountText)),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $99VqK.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dTJrO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1e3aa5f77a45f5e$export$2e2bcd8739ae039; });

var $ibpyK = parcelRequire("ibpyK");

var $ouZve = parcelRequire("ouZve");

var $lGVsg = parcelRequire("lGVsg");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $fr57R = parcelRequire("fr57R");

var $7t0tI = parcelRequire("7t0tI");
var $a1e3aa5f77a45f5e$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $a1e3aa5f77a45f5e$var$levelMap = {
    h900: 'h1',
    h800: 'h1',
    h700: 'h2',
    h600: 'h3',
    h500: 'h4',
    h400: 'h5',
    h300: 'h6',
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: 'div',
    h100: 'div'
};
var $a1e3aa5f77a45f5e$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $a1e3aa5f77a45f5e$var$h900Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $a1e3aa5f77a45f5e$var$h800Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $a1e3aa5f77a45f5e$var$h700Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $a1e3aa5f77a45f5e$var$h600Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $a1e3aa5f77a45f5e$var$h500Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $a1e3aa5f77a45f5e$var$h400Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h300Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: 'uppercase'
});
var $a1e3aa5f77a45f5e$var$h200Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h100Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $a1e3aa5f77a45f5e$var$subtlestStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $a1e3aa5f77a45f5e$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    var _useHeading = (0, $69vmd.useHeading)($a1e3aa5f77a45f5e$var$levelMap[level]), _useHeading2 = (0, $lGVsg.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === 'h200' || level === 'h100';
    var needsAriaRole = Markup === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $a1e3aa5f77a45f5e$var$headingResetStyles,
            level === 'h100' && $a1e3aa5f77a45f5e$var$h100Styles,
            level === 'h200' && $a1e3aa5f77a45f5e$var$h200Styles,
            level === 'h300' && $a1e3aa5f77a45f5e$var$h300Styles,
            level === 'h400' && $a1e3aa5f77a45f5e$var$h400Styles,
            level === 'h500' && $a1e3aa5f77a45f5e$var$h500Styles,
            level === 'h600' && $a1e3aa5f77a45f5e$var$h600Styles,
            level === 'h700' && $a1e3aa5f77a45f5e$var$h700Styles,
            level === 'h800' && $a1e3aa5f77a45f5e$var$h800Styles,
            level === 'h900' && $a1e3aa5f77a45f5e$var$h900Styles,
            color === 'inverse' && $a1e3aa5f77a45f5e$var$inverseStyles,
            color === 'default' && isSubtleHeading && $a1e3aa5f77a45f5e$var$subtlestStyles
        ]
    }, children);
};
var $a1e3aa5f77a45f5e$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $ouZve.default)(_ref2, $a1e3aa5f77a45f5e$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)($a1e3aa5f77a45f5e$var$Heading, (0, $ibpyK.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)((0, $fr57R.default), (0, $ibpyK.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("ibpyK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3cd14a2655d0b4a$export$2e2bcd8739ae039; });
function $d3cd14a2655d0b4a$export$2e2bcd8739ae039() {
    return $d3cd14a2655d0b4a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3cd14a2655d0b4a$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("ouZve", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $049a482b1accf5c7$export$2e2bcd8739ae039; });

var $g6n3W = parcelRequire("g6n3W");
function $049a482b1accf5c7$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $g6n3W.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("g6n3W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb8f18a501a91c5f$export$2e2bcd8739ae039; });
function $bb8f18a501a91c5f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lGVsg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fcaa169217ff0b79$export$2e2bcd8739ae039; });

var $lqD0N = parcelRequire("lqD0N");

var $aSqcK = parcelRequire("aSqcK");

var $jNFQ5 = parcelRequire("jNFQ5");

var $dv2kJ = parcelRequire("dv2kJ");
function $fcaa169217ff0b79$export$2e2bcd8739ae039(r, e) {
    return (0, $lqD0N.default)(r) || (0, $aSqcK.default)(r, e) || (0, $jNFQ5.default)(r, e) || (0, $dv2kJ.default)();
}

});
parcelRegister("lqD0N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f99a49a244564528$export$2e2bcd8739ae039; });
function $f99a49a244564528$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("aSqcK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7eb3463c8162570d$export$2e2bcd8739ae039; });
function $7eb3463c8162570d$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("jNFQ5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e6a30c46a6e5cbd7$export$2e2bcd8739ae039; });

var $c44Io = parcelRequire("c44Io");
function $e6a30c46a6e5cbd7$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $c44Io.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $c44Io.default)(r, a) : void 0;
    }
}

});
parcelRegister("c44Io", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $02444852bc165114$export$2e2bcd8739ae039; });
function $02444852bc165114$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dv2kJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d3ffaf4ae290bef$export$2e2bcd8739ae039; });
function $9d3ffaf4ae290bef$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("69vmd", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $47abe8463fa9d1c8$export$97a37b1befbbf9b1; });

var $gljCV = parcelRequire("gljCV");
// Allows support for heading levels 1-9 via aria-level
var $47abe8463fa9d1c8$var$HeadingLevelContext = /*#__PURE__*/ (0, $gljCV.createContext)(0);
var $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $gljCV.useContext)($47abe8463fa9d1c8$var$HeadingLevelContext);
};
var $47abe8463fa9d1c8$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $47abe8463fa9d1c8$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement($47abe8463fa9d1c8$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $47abe8463fa9d1c8$export$2e2bcd8739ae039 = $47abe8463fa9d1c8$var$HeadingLevelContextProvider;

});

parcelRegister("fr57R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b3cd5a87ca909983$export$2e2bcd8739ae039; });

var $lGVsg = parcelRequire("lGVsg");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $7t0tI = parcelRequire("7t0tI");
var $b3cd5a87ca909983$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $b3cd5a87ca909983$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: 'normal',
    marginBlock: 0,
    textTransform: 'none'
});
var $b3cd5a87ca909983$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $b3cd5a87ca909983$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $69vmd.useHeading)($b3cd5a87ca909983$var$sizeTagMap[localSize]), _useHeading2 = (0, $lGVsg.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $b3cd5a87ca909983$var$headingResetStyles,
            localSize && $b3cd5a87ca909983$var$headingSizeStylesMap[localSize],
            color === 'inverse' && $b3cd5a87ca909983$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $b3cd5a87ca909983$var$headingSizeStylesMap = {
    xxlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    large: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    medium: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    small: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xxsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    })
};
var /**
 * @codegenEnd
 */ $b3cd5a87ca909983$export$2e2bcd8739ae039 = $b3cd5a87ca909983$var$Heading;

});


parcelRegister("5yMx4", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", function () { return $40c5c63fd8f4fd26$export$a0f6cb8061290bbb; });
/* eslint-disable max-len */ 
var $gljCV = parcelRequire("gljCV");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $40c5c63fd8f4fd26$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $40c5c63fd8f4fd26$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $40c5c63fd8f4fd26$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7OBrw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b0a3f47ca61ccb4$export$2e2bcd8739ae039; });

var $halAH = parcelRequire("halAH");

var $gljCV = parcelRequire("gljCV");

var $3dJ4i = parcelRequire("3dJ4i");

var $4HBPY = parcelRequire("4HBPY");

var $2FlEO = parcelRequire("2FlEO");
var $5b0a3f47ca61ccb4$var$flexGrowMap = {
    hug: (0, $4HBPY.xcss)({
        flexGrow: 0
    }),
    fill: (0, $4HBPY.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $5b0a3f47ca61ccb4$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $5b0a3f47ca61ccb4$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $5b0a3f47ca61ccb4$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5b0a3f47ca61ccb4$var$Inline = /*#__PURE__*/ (0, $gljCV.memo)(/*#__PURE__*/ (0, $gljCV.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($5b0a3f47ca61ccb4$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $gljCV.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $gljCV.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $3dJ4i.jsx)((0, $2FlEO.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $5b0a3f47ca61ccb4$var$flexGrowMap[grow]
        ].concat((0, $halAH.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$5b0a3f47ca61ccb4$var$Inline.displayName = 'Inline';
var $5b0a3f47ca61ccb4$export$2e2bcd8739ae039 = $5b0a3f47ca61ccb4$var$Inline;

});
parcelRegister("halAH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7f41e55e0256989$export$2e2bcd8739ae039; });

var $7UhSq = parcelRequire("7UhSq");

var $bfaU9 = parcelRequire("bfaU9");

var $a89ht = parcelRequire("a89ht");

var $6zz7o = parcelRequire("6zz7o");
function $c7f41e55e0256989$export$2e2bcd8739ae039(r) {
    return (0, $7UhSq.default)(r) || (0, $bfaU9.default)(r) || (0, $a89ht.default)(r) || (0, $6zz7o.default)();
}

});
parcelRegister("7UhSq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1ba15a9a0c110d$export$2e2bcd8739ae039; });

var $hiuxB = parcelRequire("hiuxB");
function $5c1ba15a9a0c110d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $hiuxB.default)(r);
}

});

parcelRegister("bfaU9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82f98ddf9dac1907$export$2e2bcd8739ae039; });
function $82f98ddf9dac1907$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6zz7o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c9140bc4d148227$export$2e2bcd8739ae039; });
function $4c9140bc4d148227$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2FlEO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f1035ce1e22ffb5$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $gljCV = parcelRequire("gljCV");

var $3dJ4i = parcelRequire("3dJ4i");

var $bEO5x = parcelRequire("bEO5x");

var $4HBPY = parcelRequire("4HBPY");
var $1f1035ce1e22ffb5$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $1f1035ce1e22ffb5$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $1f1035ce1e22ffb5$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $1f1035ce1e22ffb5$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $1f1035ce1e22ffb5$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1f1035ce1e22ffb5$var$Flex = /*#__PURE__*/ (0, $gljCV.memo)(/*#__PURE__*/ (0, $gljCV.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $4HBPY.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        css: [
            $1f1035ce1e22ffb5$var$baseStyles,
            gap && (0, $bEO5x.spaceStylesMap).gap[gap],
            columnGap && (0, $bEO5x.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $bEO5x.spaceStylesMap).rowGap[rowGap],
            alignItems && $1f1035ce1e22ffb5$var$alignItemsMap[alignItems],
            direction && $1f1035ce1e22ffb5$var$flexDirectionMap[direction],
            justifyContent && $1f1035ce1e22ffb5$var$justifyContentMap[justifyContent],
            wrap && $1f1035ce1e22ffb5$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1f1035ce1e22ffb5$var$Flex.displayName = 'Flex';
var $1f1035ce1e22ffb5$export$2e2bcd8739ae039 = $1f1035ce1e22ffb5$var$Flex;

});


parcelRegister("9HSUa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7112b82d95dec474$export$2e2bcd8739ae039; });

var $halAH = parcelRequire("halAH");

var $gljCV = parcelRequire("gljCV");

var $3dJ4i = parcelRequire("3dJ4i");

var $4HBPY = parcelRequire("4HBPY");

var $2FlEO = parcelRequire("2FlEO");
var $7112b82d95dec474$var$flexGrowMap = {
    hug: (0, $4HBPY.xcss)({
        flexGrow: 0
    }),
    fill: (0, $4HBPY.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $7112b82d95dec474$var$Stack = /*#__PURE__*/ (0, $gljCV.memo)(/*#__PURE__*/ (0, $gljCV.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    return (0, $3dJ4i.jsx)((0, $2FlEO.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $7112b82d95dec474$var$flexGrowMap[grow]
        ].concat((0, $halAH.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$7112b82d95dec474$var$Stack.displayName = 'Stack';
var $7112b82d95dec474$export$2e2bcd8739ae039 = $7112b82d95dec474$var$Stack;

});

parcelRegister("bHlSp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8844ae1add0738ee$export$2e2bcd8739ae039; });

var $fsabC = parcelRequire("fsabC");

var $hxpiE = parcelRequire("hxpiE");

var $gljCV = parcelRequire("gljCV");

var $3dJ4i = parcelRequire("3dJ4i");

var $lmxXn = parcelRequire("lmxXn");

var $bEO5x = parcelRequire("bEO5x");

var $kADCp = parcelRequire("kADCp");
var $8844ae1add0738ee$var$_excluded = [
    "children"
];
function $8844ae1add0738ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8844ae1add0738ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8844ae1add0738ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hxpiE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8844ae1add0738ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8844ae1add0738ee$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $8844ae1add0738ee$var$resetStyles = (0, $3dJ4i.css)({
    margin: 0
});
var $8844ae1add0738ee$var$variantStyles = $8844ae1add0738ee$var$_objectSpread($8844ae1add0738ee$var$_objectSpread({}, (0, $bEO5x.bodyTextStylesMap)), (0, $bEO5x.uiTextStylesMap));
var $8844ae1add0738ee$var$strongStyles = (0, $3dJ4i.css)({
    fontWeight: 'bold'
});
var $8844ae1add0738ee$var$emStyles = (0, $3dJ4i.css)({
    fontStyle: 'italic'
});
var $8844ae1add0738ee$var$textAlignMap = {
    center: (0, $3dJ4i.css)({
        textAlign: 'center'
    }),
    end: (0, $3dJ4i.css)({
        textAlign: 'end'
    }),
    start: (0, $3dJ4i.css)({
        textAlign: 'start'
    })
};
var $8844ae1add0738ee$var$truncationStyles = (0, $3dJ4i.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $8844ae1add0738ee$var$wordBreakMap = {
    breakAll: (0, $3dJ4i.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8844ae1add0738ee$var$useColor = function useColor(colorProp) {
    var surface = (0, $kADCp.useSurface)();
    var inverseTextColor = (0, $bEO5x.inverseColorMap)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $8844ae1add0738ee$var$HasTextAncestorContext = /*#__PURE__*/ (0, $gljCV.createContext)(false);
var $8844ae1add0738ee$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $gljCV.useContext)($8844ae1add0738ee$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8844ae1add0738ee$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $fsabC.default)(_ref, $8844ae1add0738ee$var$_excluded);
    var asElement = props.as, _props$color = props.color, colorProp = _props$color === void 0 ? 'color.text' : _props$color, textAlign = props.textAlign, testId = props.testId, id = props.id, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body' : _props$variant, weight = props.weight;
    // body variants -> p
    // ui variants -> span
    var Component = asElement || (variant.includes('body') ? 'p' : 'span');
    (0, $lmxXn.default)($8844ae1add0738ee$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    // Remove the ability to bypass typescript errors for maxLines
    var maxLines;
    if ('maxLines' in props && variant.includes('body')) maxLines = props.maxLines;
    var color = $8844ae1add0738ee$var$useColor(colorProp);
    var isWrapped = $8844ae1add0738ee$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $3dJ4i.jsx)((0, $gljCV.Fragment), null, children);
    var component = (0, $3dJ4i.jsx)(Component, {
        css: [
            $8844ae1add0738ee$var$resetStyles,
            variant && $8844ae1add0738ee$var$variantStyles[variant],
            color && (0, $bEO5x.textColorStylesMap)[color],
            maxLines && $8844ae1add0738ee$var$truncationStyles,
            maxLines === 1 && $8844ae1add0738ee$var$wordBreakMap.breakAll,
            textAlign && $8844ae1add0738ee$var$textAlignMap[textAlign],
            weight && (0, $bEO5x.fontWeightStylesMap)[weight],
            asElement === 'em' && $8844ae1add0738ee$var$emStyles,
            asElement === 'strong' && $8844ae1add0738ee$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $3dJ4i.jsx)($8844ae1add0738ee$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $8844ae1add0738ee$export$2e2bcd8739ae039 = $8844ae1add0738ee$var$Text;

});

parcelRegister("l22jm", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("8IYGL")).Adg4TextUnderline; });
parcelRequire("8IYGL");

});
parcelRegister("8IYGL", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return $37a3584e5be26d24$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
const $37a3584e5be26d24$var$textStyle = null;
const $37a3584e5be26d24$var$inViewTextStyle = null;
const $37a3584e5be26d24$var$underlineStyle = null;
const $37a3584e5be26d24$var$inViewUnderlineStyle = null;
const $37a3584e5be26d24$var$hiddenText = null;
const $37a3584e5be26d24$var$visibleText = null;
const $37a3584e5be26d24$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $6ZVlx.default)(fontWeight.from),
            "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $6ZVlx.default)(underlineInset),
                    "--_p0j3r4": (0, $6ZVlx.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("8AQXb", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $8fa89a103bc738eb$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $8fa89a103bc738eb$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    loading: {
        id: "SoftwareRovoStart.Page.loading",
        defaultMessage: "Loading"
    },
    login: {
        id: "SoftwareRovoStart.Page.login",
        defaultMessage: "Login"
    },
    contactSales: {
        id: "SoftwareRovoStart.Page.contactSales",
        defaultMessage: "Contact Sales"
    },
    rovoGetStarted: {
        defaultMessage: "Get <started>started</started> with Rovo",
        description: "Title text for WAC Rovo Start_logged out page",
        id: "SoftwareRovoStart.Page.rovoGetStarted"
    },
    loginButtonRovo: {
        defaultMessage: "Log in",
        id: "SoftwareRovoStart.Page.loginButtonRovo"
    },
    rovoBodyText: {
        defaultMessage: "Log in to add it to your organization",
        id: "SoftwareRovoStart.Page.rovoBodyText"
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: "SoftwareRovoStart.Page.dontHaveAccountText"
    },
    contactAtlassianText: {
        defaultMessage: "<a>Contact Atlassian</a>",
        id: "SoftwareRovoStart.Page.contactAtlassianText"
    },
    errorScreenTitle: {
        defaultMessage: "Something went wrong",
        description: "Error screen title",
        id: "SoftwareRovoStart.Page.errorScreenTitle"
    },
    errorScreenMessageOne: {
        defaultMessage: "<a>Contact support</a> for further help or try again.",
        description: "Error screen message part one",
        id: "SoftwareRovoStart.Page.errorScreenMessageOne"
    },
    errorScreenMessageTwo: {
        defaultMessage: "To receive a quote for Rovo, <a>contact sales.</a>",
        description: "Error screen message part two",
        id: "SoftwareRovoStart.Page.errorScreenMessageTwo"
    }
});

});

parcelRegister("cxI2Y", function(module, exports) {
$parcel$export(module.exports, "ScribbleImage", function () { return $84c16d41bc354312$export$31b1a25c5f295125; });

var $dypTs = parcelRequire("dypTs");
const $84c16d41bc354312$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $84c16d41bc354312$export$31b1a25c5f295125 = $84c16d41bc354312$var$ScribbleImageComponent;

});


parcelRegister("6VYIX", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $6c345910e2c56d86$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");

var $8AQXb = parcelRequire("8AQXb");
const $6c345910e2c56d86$var$loadingCss = null;
const $6c345910e2c56d86$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $8AQXb.messages).loading),
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
};

});



parcelRegister("gsqLc", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", function () { return $88cb943b67e1fe7e$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $5yMx4 = parcelRequire("5yMx4");

var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $4HBPY = parcelRequire("4HBPY");

var $k18Zl = parcelRequire("k18Zl");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $fJCnK = parcelRequire("fJCnK");
const $88cb943b67e1fe7e$var$elevatedContainerInnerStyles = (0, $4HBPY.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.400",
    alignSelf: "stretch",
    paddingBlockStart: "space.150"
});
const $88cb943b67e1fe7e$var$contentStyles = (0, $4HBPY.xcss)({
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.200"
});
const $88cb943b67e1fe7e$var$bodyStyles = (0, $4HBPY.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    fontSize: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "400"
});
const $88cb943b67e1fe7e$var$linkStyles = null;
const $88cb943b67e1fe7e$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    (0, $gljCV.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPageErrorScreen",
            source: "softwareRovoStartPage"
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $gljCV.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "errorScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $gljCV.useCallback)(()=>fireButtonAnalytics("contactSupportLink"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $gljCV.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $k18Zl.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5yMx4.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $9HSUa.default), {
            xcss: $88cb943b67e1fe7e$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $fJCnK.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $dypTs.jsxs)((0, $9HSUa.default), {
                    xcss: $88cb943b67e1fe7e$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenTitle))
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsxs)((0, $9HSUa.default), {
                            xcss: $88cb943b67e1fe7e$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)((0, $7OBrw.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenMessageOne), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)((0, $7OBrw.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenMessageTwo), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fJCnK", function(module, exports) {
$parcel$export(module.exports, "ErrorIconImage", function () { return $ef9db3692a497100$export$a1922be2c234f039; });

var $dypTs = parcelRequire("dypTs");
const $ef9db3692a497100$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $ef9db3692a497100$export$a1922be2c234f039 = $ef9db3692a497100$var$ErrorIconComponent;

});



parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $yhhhl = parcelRequire("yhhhl");

var $ix1ma = parcelRequire("ix1ma");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-649c33d2a1";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$BASE_URL = "https://www.atlassian.com";
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $dypTs.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                    rel: "canonical",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $dypTs.jsx)("link", {
                    rel: "alternate",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $dypTs.jsx)("link", {
                        rel: "alternate",
                        href: `${$b6785f1d81c92020$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $ix1ma.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $ix1ma.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("adHov", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $770cc77e9a9570a2$export$39716b4af53f4ad; });

var $jfTaL = parcelRequire("jfTaL");

var $3sHnI = parcelRequire("3sHnI");
function $770cc77e9a9570a2$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $jfTaL.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $jfTaL.createStrictSetupError)();
        },
        cx: $3sHnI.cx,
        XCSSProp () {
            throw (0, $jfTaL.createStrictSetupError)();
        }
    };
}

});
parcelRegister("jfTaL", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $e04a372ede62fd0e$export$c4df1cb0c2b4d77c; });
const $e04a372ede62fd0e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $e04a372ede62fd0e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("3sHnI", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $2855a34b1870f1b9$export$a274e22fb40f762e; });

var $2jatx = parcelRequire("2jatx");
const $2855a34b1870f1b9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $2jatx.default)(actualStyles);
};

});



var $hI6CC = parcelRequire("hI6CC");

var $3NQOU = parcelRequire("3NQOU");
(0, $3NQOU.init)((0, $hI6CC.SoftwareRovoStartPage));


//# sourceMappingURL=software-rovo-start-page.af902261.js.map
